import * as React from 'react';

export const IconCarIdentification = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path
			fill="currentColor"
			d="M22.2,2.6H1.8C0.8,2.6,0,3.4,0,4.4c0,0,0,0,0,0v15.2c0,1,0.8,1.8,1.8,1.8c0,0,0,0,0,0h20.4
	c1,0,1.8-0.9,1.8-1.9V4.4C24,3.4,23.2,2.6,22.2,2.6C22.2,2.6,22.2,2.6,22.2,2.6z M23,19.5c0,0.4-0.3,0.8-0.8,0.8c0,0,0,0,0,0H1.8
	C1.3,20.4,1,20,1,19.6c0,0,0,0,0,0V4.4C1,4,1.3,3.6,1.8,3.6c0,0,0,0,0,0h20.4c0.4,0,0.8,0.4,0.8,0.8c0,0,0,0,0,0L23,19.5L23,19.5
	L23,19.5z M8.2,5.9H2.9v5.4h5.3V5.9z M7.2,10.3H3.9V7h3.3V10.3L7.2,10.3z M3.4,13.9h10.6v1H3.4V13.9z M3.4,17.2h10.6v1H3.4V17.2z"
		/>
	</svg>
);
